import type * as core from '../../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.universal.commonStructures',
    'package:data.universal.people',
    'resource:data.enums.jobType',
    // TODO: this is higher ed specific, why is it here?
    'resource:data.enums.jobType.entries.principalInvestigator',
    'resource:data.dimensions.organization',
    'resource:data.dimensions.organization.entities.department',
    // TODO: this is customer specific, why is it here?
    'resource:data.dimensions.organization.entities.department.attributes.shouldAnalyze',
    // Personnel
    'resource:data.dimensions.jobTitles',
    'resource:data.dimensions.jobTitles.entities.jobTitle',
    'resource:data.dimensions.jobTitles.entities.jobTitle.attributes.type',
    'resource:data.dimensions.personnel',
    'resource:data.dimensions.personnel.entities.employee',
    'resource:data.dimensions.personnel.entities.employee.attributes.person',
    'resource:data.dimensions.personnel.entities.employee.attributes.organization',
    'resource:data.dimensions.personnel.entities.employee.attributes.jobTitle',
    // Personnel Leadership
    'resource:data.enums.leaderType',
    'resource:data.enums.leaderType.entries.manager',
    'resource:data.enums.leaderType.entries.other',
    'resource:data.dimensions.personnelLeaders',
    'resource:data.dimensions.personnelLeaders.entities.relationship',
    'resource:data.dimensions.personnelLeaders.entities.relationship.attributes.leader',
    'resource:data.dimensions.personnelLeaders.entities.relationship.attributes.leaderType',
    'resource:data.dimensions.personnelLeaders.entities.relationship.attributes.personnel',
  ],
  description: 'TODO',
  name: 'Org Structure - Without Divisions',
} as const satisfies core.quiver.Package
